// extracted by mini-css-extract-plugin
export default {"entityIcon":"LockedEntityType_entityIcon__6a+XK"};